export type FontVariant = {
  url: string;
  weight?: number;
  style?: "normal" | "italic";
  format?: "truetype" | "woff2";
  local?: string;
};

export type FontConfig = {
  family: string;
  variants: FontVariant[];
};

export const CUSTOM_FONT_CONFIG: FontConfig[] = [
  {
    family: "Futura",
    variants: [
      {
        local: "Futura",
        url: "https://widget.kleep.ai/fonts/Futura/Futura-Medium.otf",
        weight: 500,
        format: "truetype",
      },
      {
        local: "Futura Extra-Bold",
        url: "https://widget.kleep.ai/fonts/Futura/FuturaExtraBold.otf",
        weight: 800,
        format: "truetype",
      },
    ],
  },
  {
    family: "FuturaProLight",
    variants: [
      {
        local: "FuturaProLight",
        url: "https://widget.kleep.ai/fonts/FuturaProLight/FuturaLTProLight.otf",
        weight: 400,
        format: "truetype",
      },
    ],
  },
  {
    family: "Graphik",
    variants: [
      {
        local: "Graphik Regular",
        url: "https://widget.kleep.ai/fonts/Graphik/GraphikRegular.otf",
        weight: 400,
        format: "truetype",
      },
      {
        local: "Graphik Medium",
        url: "https://widget.kleep.ai/fonts/Graphik/GraphikMedium.otf",
        weight: 500,
        format: "truetype",
      },
      {
        local: "Graphik Medium",
        url: "https://widget.kleep.ai/fonts/Graphik/GraphikSemibold.otf",
        weight: 600,
        format: "truetype",
      },
      {
        local: "Graphik Bold",
        url: "https://widget.kleep.ai/fonts/Graphik/GraphikBold.otf",
        weight: 700,
        format: "truetype",
      },
      {
        local: "Graphik ExtraBold",
        url: "https://widget.kleep.ai/fonts/Graphik/GraphikExtraBold.otf",
        weight: 800,
        format: "truetype",
      },
    ],
  },
  {
    family: "Times New Roman",
    variants: [
      {
        url: "https://widget.kleep.ai/fonts/TimesNewRoman/TimesNewRomanCustom.woff2",
        weight: 400,
        format: "woff2",
      },
    ],
  },
  {
    family: "Arial",
    variants: [
      {
        url: "https://widget.kleep.ai/fonts/Arial/Arial.woff2",
        weight: 400,
        format: "woff2",
      },
    ],
  },
  {
    family: "Optima",
    variants: [
      {
        local: "Optima Regular",
        url: "https://widget.kleep.ai/fonts/Optima/OPTIMA.TTF",
        weight: 400,
        format: "truetype",
      },
      {
        local: "Optima Medium",
        url: "https://widget.kleep.ai/fonts/Optima/Optima_Medium.ttf",
        weight: 500,
        format: "truetype",
      },
      {
        local: "Optima SemiBold",
        url: "https://widget.kleep.ai/fonts/Optima/Optima_Medium.ttf",
        weight: 600,
        format: "truetype",
      },
      {
        local: "Optima Bold",
        url: "https://widget.kleep.ai/fonts/Optima/OPTIMA_B.TTF",
        weight: 700,
        format: "truetype",
      },
      {
        local: "Optima ExtraBold",
        url: "https://widget.kleep.ai/fonts/Optima/OPTIMA.TTF",
        weight: 800,
        format: "truetype",
      },
    ],
  },
  {
    family: "HafferSQ",
    variants: [
      {
        local: "HafferSQ Regular",
        url: "https://widget.kleep.ai/fonts/HafferSQ/HafferSQ-Regular.ttf",
        weight: 400,
        format: "truetype",
      },
    ],
  },
  {
    family: "Vectora LT Std",
    variants: [
      {
        local: "Vectora LT Std Light",
        url: "https://widget.kleep.ai/fonts/Vectora_LT_Std/Vectora_LT_Std_Light.otf",
        weight: 300,
        format: "truetype",
      },
      {
        local: "Vectora LT Std Regular",
        url: "https://widget.kleep.ai/fonts/Vectora_LT_Std/Vectora_LT_Std.otf",
        weight: 400,
        format: "truetype",
      },
      {
        local: "Vectora LT Std Bold",
        url: "https://widget.kleep.ai/fonts/Vectora_LT_Std/Vectora_LT_Std_Bold.otf",
        weight: 700,
        format: "truetype",
      },
    ],
  },
  {
    family: "Dinot",
    variants: [
      {
        local: "Dinot Light",
        url: "https://widget.kleep.ai/fonts/Dinot/font-DINOT-Light.woff2",
        weight: 300,
        format: "woff2",
      },
      {
        local: "Dinot Regular",
        url: "https://widget.kleep.ai/fonts/Dinot/font-DINOT.woff2",
        weight: 400,
        format: "woff2",
      },
      {
        local: "Dinot Medium",
        url: "https://widget.kleep.ai/fonts/Dinot/font-DINOT-Medium.woff2",
        weight: 500,
        format: "woff2",
      },
      {
        local: "Dinot SemiBold",
        url: "https://widget.kleep.ai/fonts/Dinot/font-DINEngschriftStd.woff2",
        weight: 600,
        format: "woff2",
      },
      {
        local: "Dinot Bold",
        url: "https://widget.kleep.ai/fonts/Dinot/font-DINOT.woff2",
        weight: 700,
        format: "woff2",
      },
      {
        local: "Dinot ExtraBold",
        url: "https://widget.kleep.ai/fonts/Dinot/font-DINOT.woff2",
        weight: 800,
        format: "woff2",
      },
    ],
  },
  {
    family: "Brown",
    variants: [
      {
        local: "Brown Light",
        url: "https://widget.kleep.ai/fonts/Brown/BrownLLWeb-Light.woff2",
        weight: 300,
        format: "woff2",
      },
      {
        local: "Brown Regular",
        url: "https://widget.kleep.ai/fonts/Brown/BrownLLWeb-Regular.woff2",
        weight: 400,
        format: "woff2",
      },
      {
        local: "Brown Medium",
        url: "https://widget.kleep.ai/fonts/Brown/BrownLLWeb-Medium.woff2",
        weight: 500,
        format: "woff2",
      },
      {
        local: "Brown Bold",
        url: "https://widget.kleep.ai/fonts/Brown/BrownLLWeb-Bold.woff2",
        weight: 700,
        format: "woff2",
      },
      {
        local: "Brown Black",
        url: "https://widget.kleep.ai/fonts/Brown/BrownLLSub-Black.woff2",
        weight: 800,
        format: "woff2",
      },
    ],
  },
  {
    family: "Gilmer",
    variants: [
      {
        local: "Gilmer Light",
        url: "https://widget.kleep.ai/fonts/Gilmer/Gilmer_Light.otf",
        weight: 300,
        format: "truetype",
      },
      {
        local: "Gilmer Regular",
        url: "https://widget.kleep.ai/fonts/Gilmer/Gilmer_Regular.otf",
        weight: 400,
        format: "truetype",
      },
      {
        local: "Gilmer Medium",
        url: "https://widget.kleep.ai/fonts/Gilmer/Gilmer_Medium.otf",
        weight: 500,
        format: "truetype",
      },
      {
        local: "Gilmer Semi Bold",
        url: "https://widget.kleep.ai/fonts/Gilmer/Gilmer_Medium.otf",
        weight: 600,
        format: "truetype",
      },
      {
        local: "Gilmer Bold",
        url: "https://widget.kleep.ai/fonts/Gilmer/Gilmer_Bold.otf",
        weight: 700,
        format: "truetype",
      },
      {
        local: "Gilmer Black",
        url: "https://widget.kleep.ai/fonts/Gilmer/Gilmer_Heavy.otf",
        weight: 800,
        format: "truetype",
      },
    ],
  },
  {
    family: "AktivGrotesk",
    variants: [
      {
        local: "AktivGrotesk Light",
        url: "https://widget.kleep.ai/fonts/Aktiv_Grotesk/AktivGrotesk-Light.otf",
        weight: 300,
        format: "truetype",
      },
      {
        local: "AktivGrotesk Regular",
        url: "https://widget.kleep.ai/fonts/Aktiv_Grotesk/AktivGrotesk-Regular.otf",
        weight: 400,
        format: "truetype",
      },
      {
        local: "AktivGrotesk Medium",
        url: "https://widget.kleep.ai/fonts/Aktiv_Grotesk/AktivGrotesk-Medium.otf",
        weight: 500,
        format: "truetype",
      },
      {
        local: "AktivGrotesk Semi Bold",
        url: "https://widget.kleep.ai/fonts/Aktiv_Grotesk/AktivGrotesk-XBold.otf",
        weight: 600,
        format: "truetype",
      },
      {
        local: "AktivGrotesk Bold",
        url: "https://widget.kleep.ai/fonts/Aktiv_Grotesk/AktivGrotesk-Bold.otf",
        weight: 700,
        format: "truetype",
      },
      {
        local: "AktivGrotesk Black",
        url: "https://widget.kleep.ai/fonts/Aktiv_Grotesk/AktivGrotesk-Black.otf",
        weight: 800,
        format: "truetype",
      },
    ],
  },
  {
    family: "MillerBanner",
    variants: [
      {
        local: "MillerBanner Light",
        url: "https://widget.kleep.ai/fonts/MillerBanner/MillerBanner_Light.otf",
        weight: 300,
        format: "truetype",
      },
      {
        local: "MillerBanner Regular",
        url: "https://widget.kleep.ai/fonts/MillerBanner/MillerBanner_Regular.otf",
        weight: 400,
        format: "truetype",
      },
    ],
  },
  {
    family: "Akuratt",
    variants: [
      {
        local: "Akuratt Regular",
        url: "https://widget.kleep.ai/fonts/Akuratt/AkkuratLL-Regular.otf",
        weight: 400,
        format: "truetype",
      },
      {
        local: "Akuratt Italic",
        url: "https://widget.kleep.ai/fonts/Akuratt/AkkuratLL-Italic.otf",
        weight: 400,
        style: "italic",
        format: "truetype",
      },
      {
        local: "Akuratt Bold",
        url: "https://widget.kleep.ai/fonts/Akuratt/AkkuratLL-Bold.otf",
        weight: 700,
        format: "truetype",
      },
      {
        local: "Akuratt Bold Italic",
        url: "https://widget.kleep.ai/fonts/Akuratt/AkkuratLL-BoldItalic.otf",
        weight: 700,
        style: "italic",
        format: "truetype",
      },
    ],
  },
  {
    family: "Gravity",
    variants: [
      {
        local: "Gravity Bold",
        url: "https://widget.kleep.ai/fonts/Gravity/ABCGravity-XCompressed.otf",
        weight: 400,
        format: "truetype",
      },
    ],
  },
  {
    family: "Metropolis",
    variants: [
      {
        local: "Metropolis Regular",
        url: "https://widget.kleep.ai/fonts/Metropolis/Metropolis-Regular.otf",
        weight: 400,
        format: "truetype",
      },
      {
        local: "Metropolis Medium",
        url: "https://widget.kleep.ai/fonts/Metropolis/Metropolis-Medium.otf",
        weight: 400,
        format: "truetype",
      },
      {
        local: "Metropolis SemiBold",
        url: "https://widget.kleep.ai/fonts/Metropolis/Metropolis-SemiBold.otf",
        weight: 700,
        format: "truetype",
      },
      {
        local: "Metropolis Bold",
        url: "https://widget.kleep.ai/fonts/Metropolis/Metropolis-Bold.otf",
        weight: 700,
        format: "truetype",
      },
      {
        local: "Metropolis ExtraBold",
        url: "https://widget.kleep.ai/fonts/Metropolis/Metropolis-ExtraBold.otf",
        weight: 800,
        format: "truetype",
      },
    ],
  },
  {
    family: "Helvetica",
    variants: [
      {
        local: "Helvetica Regular",
        url: "https://widget.kleep.ai/fonts/Helvetica/helvetica_regular.otf",
        weight: 400,
        format: "truetype",
      },
      {
        local: "Helvetica Medium",
        url: "https://widget.kleep.ai/fonts/Helvetica/helvetica_regular.otf",
        weight: 400,
        format: "truetype",
      },
      {
        local: "Helvetica SemiBold",
        url: "https://widget.kleep.ai/fonts/Helvetica/helvetica_bold.otf",
        weight: 700,
        format: "truetype",
      },
      {
        local: "Helvetica Bold",
        url: "https://widget.kleep.ai/fonts/Helvetica/helvetica_bold.otf",
        weight: 700,
        format: "truetype",
      },
      {
        local: "Helvetica ExtraBold",
        url: "https://widget.kleep.ai/fonts/Helvetica/helvetica_bold.otf",
        weight: 800,
        format: "truetype",
      },
    ],
  },
  {
    family: "apercu",
    variants: [
      {
        local: "apercu Regular",
        url: "https://widget.kleep.ai/fonts/apercu/apercu_regular_pro.otf",
        weight: 400,
        format: "truetype",
      },
      {
        local: "apercu Medium",
        url: "https://widget.kleep.ai/fonts/apercu/apercu_medium_pro.otf",
        weight: 400,
        format: "truetype",
      },
      {
        local: "apercu SemiBold",
        url: "https://widget.kleep.ai/fonts/apercu/apercu_medium_pro.otf",
        weight: 700,
        format: "truetype",
      },
      {
        local: "apercu Bold",
        url: "https://widget.kleep.ai/fonts/apercu/apercu_bold_pro.otf",
        weight: 700,
        format: "truetype",
      },
      {
        local: "apercu ExtraBold",
        url: "https://widget.kleep.ai/fonts/apercu/apercu_bold_pro.otf",
        weight: 800,
        format: "truetype",
      },
    ],
  },
  {
    family: "BashTodo",
    variants: [
      {
        local: "BashTodo Regular",
        url: "https://widget.kleep.ai/fonts/BashTodo/ba&sh_todo/Ba&shTodo-medium.otf",
        weight: 400,
        format: "truetype",
      },
      {
        local: "BashTodo Medium",
        url: "https://widget.kleep.ai/fonts/BashTodo/ba&sh_todo/Ba&shTodo-medium.otf",
        weight: 400,
        format: "truetype",
      },
      {
        local: "BashTodo SemiBold",
        url: "https://widget.kleep.ai/fonts/BashTodo/ba&sh_todo/Ba&shTodo-bold.otf",
        weight: 700,
        format: "truetype",
      },
      {
        local: "BashTodo Bold",
        url: "https://widget.kleep.ai/fonts/BashTodo/ba&sh_todo/Ba&shTodo-bold.otf",
        weight: 700,
        format: "truetype",
      },
      {
        local: "BashTodo ExtraBold",
        url: "https://widget.kleep.ai/fonts/BashTodo/ba&sh_todo/Ba&shTodo-black.otf",
        weight: 800,
        format: "truetype",
      },
    ],
  },
];

export default CUSTOM_FONT_CONFIG;
